import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import ButtonIcon from "../common/ButtonIcon";
import classNames from "classnames";
import Flag from "react-flags";
import NumberFormat from "react-number-format";
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { PreloadState } from "../UI/preloading/PreloadState";
import { cleanVePhone, getVePhoneFormat } from "../../helpers/utils";

const CreateProviderForm = ({
  provider,
  handleSubmitData,
  setRedirect,
  setRedirectUrl,
  onCancel,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    control,
    formState: { isSubmitting },
    setValue,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
  });

  register("name");
  register("description");
  register("phone");
  register("dni");

  const [prefix, setPrefix] = useState("V");
  const [phoneDigits, setPhoneDigits] = useState(cleanVePhone(provider?.phone));

  const renderForm = () => (
    <>
      <FalconCardHeader title="Detalles del proveedor" light={false} />
      <CardBody>
        <Row form>
          <Col sm>
            <FormGroup>
              <Label for="name">Nombre del proveedor*</Label>
              <Input
                autoComplete="off"
                name="name"
                defaultValue={provider?.name || undefined}
                className={classNames({
                  "border-danger": errors["name"]?.message,
                })}
                onChange={(event) => {
                  register("name");
                  setValue("name", event.target.value);
                }}
                innerRef={register({
                  required: "Nombre del proveedor es requerido.",
                  minLength: {
                    value: 5,
                    message:
                      "El nombre del proveedor debe tener al menos 5 caracteres.",
                  },
                })}
                id="name"
                placeholder="Nombre del proveedor"
              />
              <WizardError
                error={errors["name"]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col sm>
            <FormGroup>
              <Label for="description">Descripción</Label>
              <Input
                id="description"
                name="description"
                defaultValue={provider?.description || undefined}
                onChange={(event) => {
                  register("description");
                  setValue("description", event.target.value);
                }}
                type="textarea"
                autoComplete="off"
                placeholder="Descripción"
                className={classNames({
                  "border-danger": errors["description"]?.message,
                })}
                innerRef={register({
                  minLength: {
                    value: 7,
                    message: "La descripción debe tener al menos 7 caracteres.",
                  },
                })}
              />
              <WizardError
                error={errors["description"]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col sm>
            <FormGroup>
              <Label for="email">Correo electrónico</Label>
              <Input
                id="email"
                name="email"
                defaultValue={provider?.email || undefined}
                type="email"
                autoComplete="off"
                placeholder="Correo electrónico"
                className={classNames({
                  "border-danger": errors["email"]?.message,
                })}
                innerRef={register({
                  pattern: {
                    value:
                      /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
                    message: "Correo electrónico debe ser válido.",
                  },
                })}
              />
              <WizardError
                error={errors["email"]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col sm>
            <FormGroup>
              <Label>ID (Cédula o RIF)</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Input
                    type="select"
                    onChange={(e) => {
                      setPrefix(e.target.value);
                    }}
                  >
                    <option value="V">V</option>
                    <option value="E">E</option>
                    <option value="J">J</option>
                    <option value="P">P</option>
                    <option value="C">C</option>
                    <option value="G">G</option>
                  </Input>
                </InputGroupAddon>
                <Controller
                  name="dni"
                  control={control}
                  /*      rules={{
                         required: {
                           value: true,
                           message: "El DNI es obligatorio",
                         },
                       }} */
                  render={({ onChange, name, value }) => (
                    <NumberFormat
                      className={`${errors?.dni?.message ? "border-danger" : ""
                        } form-control input-spin-none`}
                      onValueChange={({ value }) => {
                        setValue("dni", `${prefix}${value}`);
                        if (!value) onChange(null);
                        else onChange(`${prefix}${value}`);
                      }}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={0}
                      renderText={(value, props) => (
                        <div {...props}>{value}</div>
                      )}
                    />
                  )}
                />
                {/*         <NumberFormat
                  className={`${
                    errors["dni"]?.message ? "border-danger" : ""
                  } form-control input-spin-none`}
                  onValueChange={({ value }) => {
                    setValue("dni", `${prefix}${value}`);
                  }}
                  thousandSeparator={true}
                  getInputRef={register("dni", {
                    required: "El DNI es obligatorio",
                  })}
                  renderText={(value, props) => <div {...props}>{value}</div>}
                /> */}
              </InputGroup>
              <WizardError error={errors["dni"]?.message} className="fs--1 font-weight-normal d-block" />
            </FormGroup>
          </Col>
          <Col sm>
            <FormGroup>
              <Label>Teléfono</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Flag
                    name="VE"
                    format="png"
                    pngSize={32}
                    className="mr-2"
                    shiny={false}
                    basePath="/flags"
                    alt="Venezuelan Flag"
                  />
                </InputGroupAddon>
                <NumberFormat
                  type="tel"
                  placeholder="04241234567 o 4241234567"
                  value={phoneDigits}
                  className={`form-control input-spin-none ${errors["description"]?.message ? "border-danger" : ""
                    }`}
                  onValueChange={({ value }) => {
                    const cleaned = cleanVePhone(value);
                    setPhoneDigits(cleaned);
                    setValue("phone", cleaned);
                  }}
                  format={getVePhoneFormat(phoneDigits)}
                />
                <WizardError
                  error={errors["phone"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>

        <Row form>
          <Col sm>
            <FormGroup>
              <Label for="description">Dirección</Label>
              <Input
                id="address"
                name="address"
                defaultValue={provider?.address || undefined}
                onChange={(event) => {
                  register("address");
                  setValue("address", event.target.value);
                }}
                type="textarea"
                autoComplete="off"
                placeholder="Dirección"
                className={classNames({
                  "border-danger": errors["address"]?.message,
                })}
                innerRef={register({
                  minLength: {
                    value: 5,
                    message: "La dirección debe tener al menos 5 caracteres.",
                  },
                })}
              />
              <WizardError
                error={errors["address"]?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-end">
            <ButtonIcon
              color="falcon-default"
              className="ml-auto px-5 mr-2"
              icon={faUndo}
              onClick={() => {
                if (onCancel) {
                  onCancel();
                } else {
                  setRedirect(true);
                  setRedirectUrl("/dashboard/providers");
                }
              }}
              iconAlign="right"
              transform="down-1 shrink-4"
            >
              Volver
            </ButtonIcon>
            <ButtonIcon
              data-testid="submit-button"
              color="primary"
              className="px-5 ml-2"
              type="submit"
              icon="save"
              iconAlign="right"
              /*  disabled={Object.keys(errors).length > 0} */
              disabled={isSubmitting}
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </Col>
        </Row>
      </CardBody>
    </>
  );

  return (
    <Card
      data-testid="form"
      tag={Form}
      className="bg-light"
      onSubmit={(event) => {
        event.stopPropagation();
        handleSubmit(handleSubmitData)(event);
      }}
    >
      <PreloadState loading={isSubmitting} message="Guardando proveedor...">
        {renderForm()}
      </PreloadState>
    </Card>
  );
};

export default CreateProviderForm;
